import { bindActionCreators } from "redux"
import { useDispatch } from "react-redux"
import { useMemo } from "react"

export const createActionsHook = (actionCreators) => () => {
  const dispatch = useDispatch()
  return useMemo(() => bindActionCreators(actionCreators, dispatch), [dispatch])
}